import MarcasProcessos from "./MarcasProcessos";

export default MarcasProcessos;